import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../../lib/blockingFetch"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import FixRecordingInFineract from "../../fragments/FixRecordingInFineract"
import SimpleCheckboxRow from "../../fragments/SimpleCheckboxRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { Link } from "react-router"

class AccountingRuleCard extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    runningFix: false,
    fixDone: false,
    error: null,
  }

  resubmitInFineract = id => {

    this.setState({
      runningFix: true,
      fixDone: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.triggerAccountingRuleRecording(accessToken, id),
      _ => this.setState({ fixDone: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningFix: false })
    )
  }

  checkRecording = item => {

    const { fixDone, runningFix, error } = this.state
    if(item.fineractId !== 0 || fixDone || !this.isAdminOrAccountant) return null
    return <FixRecordingInFineract
      running={ runningFix } error={ error }
      onClick={() => this.resubmitInFineract(item.id)}
    />
  }

  renderButtonToolbar = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/accountingrules/${id}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button> &nbsp;

        <Button bsStyle="success" onClick={() => browserHistory.push('/accountingrules/create')}>
          <FontAwesome name='plus-circle' /> New rule
        </Button>
      </div>
    )
  }

  getAccountLink = (id, name, glCode) => {

    let link = '-'
    if (id !== null && name != null) {
      link = <Link to={`/glaccounts/${id}/detail`} title="View">
        { `${ name } (${ glCode })` }
      </Link>
    }
    return link
  }

  showItem = item => {

    if(!item) return null

    let { accountToDebit, accountToCredit } = item
    accountToDebit = accountToDebit ? accountToDebit : {}
    accountToCredit = accountToCredit ? accountToCredit : {}

    const { id: glIdD, name: glNameD, glCode: glCodeD } = accountToDebit,

      { id: glIdC, name: glNameC, glCode: glCodeC } = accountToCredit,

      { id, name, description, allowMultipleDebitEntries, allowMultipleCreditEntries, createdOn } = item

    return (
      <Col md={8} className='detail-content'>

        { this.checkRecording(item) }

        <h2 className="blue">{ name }</h2>

        <SimpleCardRow name='Account to debit' value={
          this.getAccountLink(glIdD, glNameD, glCodeD) } />
        <SimpleCardRow name='Account to credit' value={
          this.getAccountLink(glIdC, glNameC, glCodeC) } />
        <SimpleCheckboxRow text='Allow Multiple Debit Entries' value={ allowMultipleDebitEntries } />
        <SimpleCheckboxRow text='Allow Multiple Credit Entries' value={ allowMultipleCreditEntries } />
        <SimpleCardRow name='Description' value={ description ? description : '-' } />
        <SimpleCardRow name='Created On' value={ createdOn ? moment(createdOn).format('lll') : '' }
          className='gray font-size-13' />

        { this.renderButtonToolbar(id) }

      </Col>
    )
  }

  render() {
    const { accountingRule } = this.props,
    dataBreadCrumbs = [
      { url: '/accounting', title: 'Accounting' },
      { url: '/accountingrules', title: 'Accounting rules' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ accountingRule.name } data={ dataBreadCrumbs } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="lock" size="3x" className="detail-icon" />
          </Col>

          { this.showItem(accountingRule) }
        </Row>
      </div>
    )
  }
}

AccountingRuleCard.propTypes = {
  accountingRule: PropTypes.object.isRequired,
}

export default AccountingRuleCard



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/Card.js